import { MORTGAGE_CLUB_OPTIONS, NETWORK_OPTIONS, SubmissionFunnelTypeEnum } from './types';

export const submissionQuestions: Record<string, any> = {
  submissionFunnelType: {
    labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.label',
    options: [
      {
        labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.option.direct.label',
        value: SubmissionFunnelTypeEnum.DIRECT,
      },
      {
        labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.option.mortgageClub.label',
        value: SubmissionFunnelTypeEnum.MORTGAGE_CLUB,
      },
      {
        labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.option.network.label',
        value: SubmissionFunnelTypeEnum.NETWORK,
      },
    ],
  },
  organisationId: {
    labelKey: 'applicationForm.SUBMISSION.organisationId.label',
  },
  organisationName: {
    labelKey: 'applicationForm.SUBMISSION.organisationName.label',
    options: {
      mortgageClub: MORTGAGE_CLUB_OPTIONS.map(option => ({ label: option, value: option })),
      network: NETWORK_OPTIONS.map(option => ({ label: option, value: option })),
    },
  },
};
